import api from "@/lib/api";

export async function fetchInstagramPosts(params = {}) {
  const { data } = await api.get("/instagram-posts", { params });
  return data;
}
export async function adminListInstagram() {
  const { data } = await api.get("/admin/instagram-posts");
  return data;
}
export async function adminCreateInstagram(payload) {
  const { data } = await api.post("/admin/instagram-posts", payload);
  return data;
}
export async function adminUpdateInstagram(id, payload) {
  const { data } = await api.put(`/admin/instagram-posts/${id}`, payload);
  return data;
}
export async function adminDeleteInstagram(id) {
  await api.delete(`/admin/instagram-posts/${id}`);
}
